import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import type { WrapperResponse } from '../core/models';

export interface EmailSignatureDTO {
  id: number;
  name: string;
  layoutId: string;
  html: string;
  fieldsJson?: string | null;
  customHtml: boolean;
  state?: 'ACTIVE' | 'INACTIVE';
  createdAt?: string;
  updatedAt?: string;
}

export interface CreateEmailSignatureRequest {
  name: string;
  layoutId: string;
  html: string;
  fieldsJson?: string;
  customHtml?: boolean;
}

export interface UpdateEmailSignatureRequest extends CreateEmailSignatureRequest {}

export type WrapperResponseEmailSignatureDTO = WrapperResponse<EmailSignatureDTO>;
export type WrapperResponseListEmailSignatureDTO = WrapperResponse<EmailSignatureDTO[]>;

@Injectable({
  providedIn: 'root'
})
export class EmailSignatureService {
  private http = inject(HttpClient);
  private apiUrl = `${environment.apiUrl}/email-signatures`;

  list(): Observable<WrapperResponseListEmailSignatureDTO> {
    return this.http.get<WrapperResponseListEmailSignatureDTO>(this.apiUrl);
  }

  getById(id: number): Observable<WrapperResponseEmailSignatureDTO> {
    return this.http.get<WrapperResponseEmailSignatureDTO>(`${this.apiUrl}/${id}`);
  }

  create(request: CreateEmailSignatureRequest): Observable<WrapperResponseEmailSignatureDTO> {
    return this.http.post<WrapperResponseEmailSignatureDTO>(this.apiUrl, request);
  }

  update(id: number, request: UpdateEmailSignatureRequest): Observable<WrapperResponseEmailSignatureDTO> {
    return this.http.put<WrapperResponseEmailSignatureDTO>(`${this.apiUrl}/${id}`, request);
  }

  delete(id: number): Observable<WrapperResponseEmailSignatureDTO> {
    return this.http.delete<WrapperResponseEmailSignatureDTO>(`${this.apiUrl}/${id}`);
  }
}
